function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-Portal-/-16-/-Upgrade",
  fill: "#95A0B3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.75 8.558a3.057 3.057 0 011.75 2.754v1.313h7v-1.313c0-1.216.72-2.262 1.75-2.754v-3.37c0-.725-.589-1.313-1.313-1.313h-.874v2.187c0 .725-.59 1.313-1.313 1.313h-3.5a1.314 1.314 0 01-1.313-1.313V3.875h-.875c-.723 0-1.312.588-1.312 1.312v3.37zM17 9.562a.439.439 0 00-.438-.437 2.19 2.19 0 00-2.187 2.187v1.75a.437.437 0 01-.438.438H6.064a.437.437 0 01-.438-.438v-1.75a2.19 2.19 0 00-2.188-2.187.439.439 0 00-.437.437v5.25A2.19 2.19 0 005.188 17h9.625A2.19 2.19 0 0017 14.812v-5.25zM8.25 6.5a.438.438 0 01-.438-.438V3h4.375v3.062a.438.438 0 01-.437.438h-3.5z",
  id: "Upgrade"
})))));